<div class="klab-toast-container" [ngClass]="[direction, size]" *ngIf="config">
    <div class="klab-toast klab-toast--v2" [ngClass]="'klab-toast--' + size" [@fadeInOut]>

        <div class="klab-toast__header">
            <button class="klab-toast__close" [class.klab-toast__close--hidden]="!closable"
                [disabled]="hasLoadingAction"
                (click)="closable && !hasLoadingAction && cerrar()" [attr.aria-hidden]="!closable" [attr.tabindex]="closable ? 0 : -1">
                <core-ui-icon name="icon_close" size="base"></core-ui-icon>
            </button>
        </div>

        <div class="klab-toast__icon-wrapper" [ngClass]="toastType">
            <core-ui-icon class="klab-toast__icon" [name]="iconName" [color]="iconColor">
            </core-ui-icon>
        </div>

        <div class="klab-toast__body">
            <h3 class="klab-toast__title">{{ title }}</h3>
            <p class="klab-toast__msg" *ngIf="messageHtml; else plainMessage" [innerHTML]="messageHtml"></p>
            <ng-template #plainMessage>
                <p class="klab-toast__msg">{{ message }}</p>
            </ng-template>
        </div>

        <div class="klab-toast__footer" *ngIf="actions.length">

            <div class="klab-toast__divider"></div>

            <div class="klab-toast__actions">
                <button type="button" class="klab-toast__btn" *ngFor="let a of actions" [ngClass]="{
                        'klab-toast__btn--primary': a.role === 'primary',
                        'klab-toast__btn--danger': a.role === 'danger',
                        'klab-toast__btn--loading': isActionLoading(a)
                    }"
                    [disabled]="a.disabled || isActionLoading(a) || hasLoadingAction"
                    [attr.aria-busy]="isActionLoading(a)"
                    (click)="onActionClick(a)">
                    <core-ui-inline-loading
                        *ngIf="isActionLoading(a); else actionLabel"
                        [sizePx]="22"
                        variant="dots"
                        color="currentColor"
                    ></core-ui-inline-loading>

                    <ng-template #actionLabel>{{ a.label }}</ng-template>
                </button>
            </div>

        </div>

    </div>
</div>
